// In-memory tech-gate session store.
// ΟΧΙ React Context, ΟΧΙ sessionStorage/localStorage: ζει μόνο στη μνήμη του tab,
// επιβιώνει navigation μεταξύ /admin · /items-management · /hotspot-editor · /add-boat,
// και χάνεται σε reload/close+reopen → ο gate ξαναζητάει (per spec test).
export type GateSession = { code: string; name: string; role: string };

let _session: GateSession | null = null;

export function getGateSession(): GateSession | null {
  return _session;
}

export function setGateSession(s: GateSession | null): void {
  _session = s;
}
